import { Condition } from "../dynamic-form/types";

export function evaluateCondition(condition: Condition, valueRetriever: (fieldName: string) => string | number | boolean) {
  switch (condition.operator) {
    case "equals":
      return valueRetriever(condition.fieldName) === condition.value;
    case "notEquals":
      return valueRetriever(condition.fieldName) !== condition.value;
    default:
      return false;
  }
}